import type { ErrorInfo } from 'react'
import { HotmartRum } from '@hot-observability-js/react'

export const logError = (error: Error, errorInfo: ErrorInfo) => {
  HotmartRum.withScope((scope) => {
    scope.setLevel('error')

    if (error.name === 'ChunkLoadError') {
      HotmartRum.captureMessage('ChunkLoadError captured successfully!')
    }

    HotmartRum.captureMessage(errorInfo.componentStack.toString())
    HotmartRum.captureException(error)
  })

  if (process.env.NODE_ENV !== 'production') {
    console.error(`Uncaught error: ${JSON.stringify({ error, errorInfo })}`)
  }
}
